var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 33504"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 11 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.227806 0.227806C0.531547 -0.0759353 1.02401 -0.0759353 1.32775 0.227806L13.7722 12.6723C14.0759 12.976 14.0759 13.4685 13.7722 13.7722C13.4685 14.0759 12.976 14.0759 12.6723 13.7722L0.227806 1.32775C-0.0759353 1.02401 -0.0759353 0.531547 0.227806 0.227806Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 12 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7722 0.227806C13.4685 -0.0759353 12.976 -0.0759353 12.6723 0.227806L0.227805 12.6723C-0.0759354 12.976 -0.0759354 13.4685 0.227805 13.7722C0.531547 14.0759 1.02401 14.0759 1.32775 13.7722L13.7722 1.32775C14.0759 1.02401 14.0759 0.531547 13.7722 0.227806Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.13cc95b9ecec13f7b396a94d37b18e37.svg";
export { ForwardRef as ReactComponent };